import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { SupplierList } from './model'

// Get all suppliers
export function useAllSuppliers(): FetchResult<SupplierList> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<SupplierList>,
    FetchError
  >(`/SelfServices/Suppliers`, fetchJson<SupplierList>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
